import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { ImgThumbPipe } from './img-thumb.pipe';
import { SanitizeHTMLPipe } from './sanitize-html.pipe';
import { SanitizeURLPipe } from './sanitize-url.pipe';
import { ChallengeStatusPipe } from './challenge.pipe';
import { FormatNumberPipe } from './format-number.pipe';
const pipes = [FormatNumberPipe, ExcerptPipe, GetValueByKeyPipe, RelativeTimePipe, ImgThumbPipe, SanitizeHTMLPipe, SanitizeURLPipe, ChallengeStatusPipe];

@NgModule({
	imports: [CommonModule],
	declarations: pipes,
	exports: pipes
})
export class SharedPipesModule {}
